import { useEffect } from "react";
import { getAllClientInfo } from "../../api/user";
import { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { getLang } from "../../features/app/UserRelatedSlice";
import { useSelector } from "react-redux";
import { getLayoutMenubarHeight } from "../../features/layouts/layoutsSlice";

interface ClientInfoType {
  id: number;
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  mobile: string;
  wechat: string;
  date: Date;
}

export default function ClientInfo() {
  const [rowData, setRowData] = useState([]);
  const lang = useSelector(getLang);
  const menubarHeight = useSelector(getLayoutMenubarHeight);
  const [columnDefs] = useState<any>([
    { headerName: "ID", field: "id", sortable: true, filter: true },
    {
      headerName: "First Name",
      field: "firstName",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Last Name",
      field: "lastName",
      sortable: true,
      filter: true,
    },
    { headerName: "Title", field: "title", sortable: true, filter: true },
    { headerName: "Email", field: "email", sortable: true, filter: true },
    { headerName: "Mobile", field: "mobile", sortable: true, filter: true },
    { headerName: "Wechat", field: "wechat", sortable: true, filter: true },
    {
      headerName: "Date",
      field: "date",
      sortable: true,
      filter: true,
      valueFormatter: (params: any) =>
        params.value ? new Date(params.value).toLocaleDateString() : "",
    },
  ]);

  useEffect(() => {
    (async () => {
      const data = await getAllClientInfo();
      setRowData(data);
    })();
  }, []);

  return (
    <div className="p-10">
      <p className="text-secondary-dark font-bold text-xl mb-3">
        {lang ? "Potential Client Information" : "潜在客户信息"}{" "}
      </p>
      <div
        className="ag-theme-alpine"
        style={{ height: `calc(100vh - ${menubarHeight}px)`, width: "100%" }}
      >
        <AgGridReact<ClientInfoType> rowData={rowData} columnDefs={columnDefs} />
      </div>
    </div>
  );
}
